module.exports = __webpack_public_path__ + "img/media_4.10fc0723.png";